import { MagnifyingGlassIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { SimpleInput } from "@/core/components/ui/simple-input";
import { Stack } from "@/core/components/ui/stack";
import { TeamFilter } from "@/payroll/teams/team-filter";
import { RosterFilterControls } from "./roster-filter-controls";
import type {
  PayrollTeam,
  PayrollRosterFilterField,
  PayrollRosterFieldFilters,
} from "./types";

interface RosterDisplayControlsProps {
  filterFields: PayrollRosterFilterField[];
  teams: PayrollTeam[];
  teamIds: string[];
  onTeamIdsChange: (ids: string[]) => void;
  search: string;
  filters: PayrollRosterFieldFilters;
  onSearchChange: (search: string) => void;
  onFiltersChange: (filters: PayrollRosterFieldFilters) => void;
}

export const RosterDisplayControls = ({
  filterFields,
  teams,
  teamIds,
  onTeamIdsChange,
  search,
  filters,
  onSearchChange,
  onFiltersChange,
}: RosterDisplayControlsProps) => (
  <Stack
    direction="row"
    align="start"
    gap="sm"
    fullWidth
    className="shrink-0 flex-wrap"
  >
    <Stack gap="none" className="w-[19rem] max-w-full shrink-0 [&>div]:w-full">
      <SimpleInput
        value={search}
        aria-label="Search roster by name or ServiceTitan ID"
        placeholder="Search name or ID"
        startAdornment={<MagnifyingGlassIcon className="size-5" />}
        endAdornment={
          search ? (
            <button
              type="button"
              aria-label="Clear search"
              onClick={() => onSearchChange("")}
              className="flex size-5 items-center justify-center rounded-full text-secondary-text transition-colors hover:text-primary-text"
            >
              <XMarkIcon className="size-4" />
            </button>
          ) : undefined
        }
        onChange={(event) => onSearchChange(event.target.value)}
        className="h-9 bg-card text-sm placeholder:text-sm placeholder:leading-5 md:text-sm"
      />
    </Stack>
    {(filterFields.length > 0 || teams.length > 1 || teamIds.length > 0) && (
      <Stack gap="none" className="min-w-0 flex-1 basis-[32rem]">
        <RosterFilterControls
          filterFields={filterFields}
          leadingFilter={
            <TeamFilter
              teams={teams}
              value={teamIds}
              onChange={onTeamIdsChange}
            />
          }
          filters={filters}
          onChange={onFiltersChange}
        />
      </Stack>
    )}
  </Stack>
);
